var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('./../../template/msg/mix-msg-item.html');
var config = require('./../../global/config');
var getImgParams = require('./../../global/utils').convertImgParams;
var ActionType = require('./../../constant/ActionType'); 
var dispatcher = require('./../../global/dispatcher');
var utils = require('../../global/utils');

var MixMsgItem = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);
};

MixMsgItem.prototype = Object.create(BaseMsgItem.prototype);
MixMsgItem.prototype.renderContent = function () {
  var self = this;
  var msg = this._data.msg;
  if (!msg) {
    return false;
  }
  var content = msg.content;
  var element = this._element;
  var title = element.find('.im-mix-title');
  var detail = element.find('.im-mix-detail');
  var img = element.find('.im-mix-img');
  var a = element.find('.im-mix-content');
  var more = element.find('.im-mix-more');
  var defHref = 'javascript:void(0)';

  // content
  if (!content.card_action_pc_url || content.card_action_pc_url === '') {
    
    a[0].addEventListener('click', function () {
      if(!content.card_action_url || content.card_action_url ===''){
        return
      }
      a.attr('href', 'javascript:;');
      var text = '请在手机端58APP中查看详情';
      dispatcher.dispatch({
        type: ActionType.TOAST_SHOW,
        data: {
          content: text,
          interval: 2000
        }
      });
    })
  } else {
    a.attr('href', content.card_action_pc_url);
  }

  // title
  if (content.card_title && content.card_title !== '') {
    title.text(content.card_title);
  } else {
    title.css('display', 'none');
  }
  

  // detail
  if (content.card_content && content.card_content !== '') {
    detail.text(content.card_content);
  } else {
    detail.css('display', 'none');
  }
 // 查看更多 im-mix-more,区分是否是用户名片邀请
  if(content.card_action_url && content.card_action_url !==''){

  }else{
    more.css('display', 'none');
  }
  if (content.card_picture_url && content.card_picture_url !== '') {
    /*  var params = {
     width: content.card_picture_w,
     height: content.card_picture_h,
     baseWidth: 265,
     unit: 'px'
     };
     var imgParams = getImgParams(params);*/
    img.attr('src', content.card_picture_url);
    /*img.css(
     {
     'height': imgParams.height,
     'width': imgParams.width
     
     });*/
  } else {
    img.css('display', 'none');
  }

  element.find('.im-msg-content').on('click', '[href]', function(e) {
    e.preventDefault();
    var url_jump = $(this).attr('href');
    if (url_jump != defHref) {
      utils.openPage(url_jump, null, null, true);
    }
  });
};

module.exports = MixMsgItem;
